// TelcoTrack — contextual sidebar hub navigation (App Nastavení, …)

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SidebarHubNavItem {
  id: string;
  label: string;
  routerLink: string[];
  /** Optional Heroicons outline paths (viewBox 0 0 24 24) for hub sidebar rows. */
  iconPaths?: readonly string[];
}

export interface SidebarHubNavState {
  active: boolean;
  hubTitle: string;
  backRouterLink: string[];
  backLabel: string;
  items: SidebarHubNavItem[];
}

const INACTIVE: SidebarHubNavState = {
  active: false,
  hubTitle: '',
  backRouterLink: ['/dashboard'],
  backLabel: 'Zpět',
  items: [],
};

@Injectable({ providedIn: 'root' })
export class SidebarHubNavService {
  private readonly stateSubject = new BehaviorSubject<SidebarHubNavState>(INACTIVE);
  readonly state$ = this.stateSubject.asObservable();

  activate(state: Omit<SidebarHubNavState, 'active'>): void {
    this.stateSubject.next({ ...state, active: true });
  }

  deactivate(): void {
    this.stateSubject.next(INACTIVE);
  }
}
